// extracted by mini-css-extract-plugin
export default {"mainContainer":"GitHubOAuthCallback_mainContainer__RCiwW","mainTip":"GitHubOAuthCallback_mainTip__-O5nL"};